import { render, staticRenderFns } from "./ListadoProductos.vue?vue&type=template&id=45d7735e&scoped=true"
import script from "./ListadoProductos.vue?vue&type=script&lang=js"
export * from "./ListadoProductos.vue?vue&type=script&lang=js"
import style0 from "./ListadoProductos.vue?vue&type=style&index=0&id=45d7735e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d7735e",
  null
  
)

export default component.exports